import axios from 'axios';
import { toast } from "react-toastify";

const PROXY = process.env.REACT_APP_URL + "api/";

export const postAgencyRent = (data) => async (dispatch) => {
  try{
    const res=await axios.post(`${PROXY}agency-rent/add`,data);
  
    return res;
  }catch(err){
   toast.error(err?.response?.data?.message)
  }
  

}
